import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DocumentManagementService } from 'src/app/modules/shared/services/document-management/document-management.service';
import { DocumentViewerService } from 'src/app/modules/shared/services/document-viewer.service';
import { AppMainService } from 'src/app/app-main.service';
import { DownloadDocumentPayload } from 'src/app/modules/shared/models/document-management/document-management.model';

@Component({
  selector: 'app-file-viewer',
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.scss'],
  providers: [MessageService]
})
export class FileViewerComponent {
  @Input() displayDialog: boolean = false;
  @Input() displayType: 'files' | 'pics' = 'files';
  @Input() displayItems: any[] = [];
  
  @Output() displayDialogChange = new EventEmitter<boolean>();

  constructor(
    private documentManagementService: DocumentManagementService,
    private documentViewerService: DocumentViewerService,
    private appMainService: AppMainService,
    private messageService: MessageService
  ) {}

  hideFileViewModal() {
    this.displayDialog = false;
    this.displayItems = [];
    this.displayDialogChange.emit(false);
  }

  previewListingFile(event: any, file: any, isDownload: boolean) {
    event.preventDefault();
    event.stopPropagation();

    const documentPayload: DownloadDocumentPayload = {
      id: file.id,
      isDefaultContentType: isDownload,
      expirationTimeInMinutes: 5
    };

    this.appMainService.isShowSpinner('previewListingFile');
    this.documentManagementService.downloadDocument(documentPayload).subscribe(
      (response: any) => {
        this.appMainService.isHideSpinner('previewListingFile');
        if (isDownload) {
          const fileUrl = response?.downloadLink;
          if (fileUrl) {
            window.open(fileUrl, '_blank');
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'File downloaded successfully' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'File URL is not available' });
          }
        } else {
          const getFileExtension = (filename: string) => filename.split('.').pop() || '';
          const extension = getFileExtension(file.fileName);
          this.documentViewerService.previewDocument(extension, response);
        }
      },
      (error) => {
        this.appMainService.isHideSpinner('previewListingFile');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to download file' });
      }
    );
  }
} 